// removed by extract-text-webpack-plugin
module.exports = {"root":"root_2Hlj-","overlay":"overlay_3gM1J"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/style.css
// module id = 206
// module chunks = 0